// shared/filters/actions.js

import { filtersInitialState } from "./filtersState";

export const makeFiltersActions = (set, get, listType) => {
  // Generate unique action names per listType to avoid collisions when spreading
  const prefix = listType.charAt(0).toUpperCase() + listType.slice(1);

  const computeDefaultFilters = () => {
    const defaultsByType =
      listType === "drafts"
        ? { status: "0" }
        : listType === "submits"
        ? { status: "2" }
        : listType === "approvals"
        ? { status: "1" }
        : listType === "approved"
        ? { status: "2" }
        : listType === "nearMissListDrafts"
        ? { status: "Draft" }
        : listType === "nearMissListSubmits"
        ? { status: "Submitted" }
        : listType === "safetyAuditListDrafts"
        ? { status: "Drafts" }
        : listType === "safetyAuditListSubmits"
        ? { status: "Submits" }
        : listType === "incidentInvestigationListDrafts"
        ? { status: "Drafts" }
        : listType === "incidentInvestigationListSubmits"
        ? { status: "Submits" }
        : { status: "" };
    return filtersInitialState(defaultsByType);
  };

  return {
    ["update" + prefix + "Filter"]: (filter) => {
      set((s) => ({
        delLists: {
          ...s.delLists,
          [listType]: {
            ...s.delLists[listType],
            filters: { ...s.delLists[listType].filters, ...filter },
          },
        },
      }));
    },

    ["clear" + prefix + "Filters"]: () => {
      const defaultFilters = computeDefaultFilters();
      set((s) => ({
        delLists: {
          ...s.delLists,
          [listType]: {
            ...s.delLists[listType],
            filters: defaultFilters,
          },
        },
      }));
    },

    ["reset" + prefix + "FiltersToInitial"]: () => {
      const defaultFilters = computeDefaultFilters();
      set((s) => ({
        delLists: {
          ...s.delLists,
          [listType]: {
            ...s.delLists[listType],
            filters: defaultFilters,
          },
        },
      }));
    },
  };
};
